<template>
  <section>
    <h1 class="text-h3 mb-8">
      Steppers
    </h1>
    <v-sheet
      class="mb-4 px-6 py-4"
      outlined
      rounded
    >
      <div class="d-flex">
        <v-checkbox
          v-model="altLabels"
          label="Alternate label"
        />
        <v-checkbox
          v-model="flat"
          class="ml-8"
          label="Flat"
        />
        <v-checkbox
          v-model="outlined"
          class="ml-8"
          label="Outlined"
        />
      </div>
      <v-stepper
        value="2"
        :alt-labels="altLabels"
        :flat="flat"
        :outlined="outlined"
      >
        <v-stepper-header>
          <v-stepper-step
            step="1"
          >
            Name of step 1
          </v-stepper-step>
          <v-divider />
          <v-stepper-step
            step="2"
          >
            Name of step 2
            <small>Optional</small>
          </v-stepper-step>
          <v-divider />
          <v-stepper-step step="3">
            Name of step 3
          </v-stepper-step>
        </v-stepper-header>
      </v-stepper>
      <v-stepper
        class="mt-8"
        :alt-labels="altLabels"
        :flat="flat"
        :outlined="outlined"
        non-linear
      >
        <v-stepper-header>
          <v-stepper-step
            step="1"
            editable
          >
            Select campaign settings
          </v-stepper-step>
          <v-divider />
          <v-stepper-step
            step="2"
            editable
          >
            Create an ad group
          </v-stepper-step>
          <v-divider />
          <v-stepper-step
            step="3"
            edit-icon="fa-regular fa-pen"
            complete
            editable
          >
            Create an ad
          </v-stepper-step>
        </v-stepper-header>
      </v-stepper>
      <v-stepper
        class="mt-8"
        :alt-labels="altLabels"
        :flat="flat"
        :outlined="outlined"
      >
        <v-stepper-header>
          <v-stepper-step step="1">
            Ad unit details
          </v-stepper-step>
          <v-divider />
          <v-stepper-step
            :rules="[() => false]"
            step="2"
          >
            Ad templates
            <small>Alert message</small>
          </v-stepper-step>
          <v-divider />
          <v-stepper-step step="3">
            Ad sizes
          </v-stepper-step>
        </v-stepper-header>
      </v-stepper>
    </v-sheet>
    <h2 class="text-h4 mb-4">
      Further reading
    </h2>
    <external-link href="https://vuetifyjs.com/en/components/steppers/">
      <strong>Steppers</strong>
    </external-link>
  </section>
</template>

<script>
export default {
  name: 'ComponentsSteppers',
  data: () => ({
    altLabels: false,
    flat: false,
    outlined: false
  })
}
</script>
